/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/*
TODO: Content of this file was mainly copeid from frontend/src/components/tooltips/utils.ts!
  It was modified a bit. When dropdownFormPresenter is no longer used (is substituted with ZenObjectsDropdown), remove the aforementoned file.
*/

/**
 * Returns person label depending on whether person has both email and name
 * or just email, i.e.:
 * "Name (name@email.com) - Administrator", or
 * "name@email.com - Administrator"
 */
export function getPersonFullLabel(person: Person): string {
  // TODO: Remove duplicate from frontend/src/components/tooltips/utils.ts!
  const { label, email, role } = person;

  if (!role) {
    return `${label}`;
  }

  if (label && label && label !== email) {
    return `${label} (${email}) - ${role}`;
  }
  return `${email} - ${role}`;
}

function getTooltipTitle(person: Person): string {
  // TODO: Remove duplicate from frontend/src/components/tooltips/utils.ts!
  if (person.role && person.email) {
    const title = person.label !== person.email ? person.label : '';
    return `
      <h1 class="info-tooltip--title">${title}</h1>
      <p class="info-tooltip--code">${person.email}</p>
      <p class="info-tooltip--role">${person.role}</p>
    `;
  }
  return '';
}

export function getTooltipData(person: Person) {
  // TODO: Remove duplicate from frontend/src/components/tooltips/utils.ts!
  if (person.role && person.email) {
    return {
      title: getTooltipTitle(person),
      variant: 'info',
      html: true,
      template: `<div class="info-tooltip" role="tooltip">
          <div class="tooltip-inner"></div>
        </div>`,
      offset: '0, 5',
    };
  }
  return {};
}
